import { graphql } from 'react-relay';

export const ViewPageGatewayQuery = graphql`
	query ViewPageGatewayQuery($contentId: ID) {
		content(id: $contentId) {
			nodes {
				id
				status
			}
		}
	}
`;
